import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const propTypes = {
  containerFontClass: PropTypes.string,
  containerClassName: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
};

const Header = ({ containerFontClass= 'subhead', containerClassName, text }) => {
  return (
    <h2 
      data-testid="principalPaydownHeroHeader"
      className={classNames(containerFontClass,'-darkBlue', containerClassName)}
      >
      {text}
    </h2>
  );
};

Header.propTypes = propTypes;
export default Header;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/Hero/Header.js